// core
import React from 'react';
import { Link } from 'react-router-dom'
import { Provider } from "react-redux"

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

class MailingViewerPage extends React.Component {
  constructor(props) {
    super(props);

    this.statsFetchT = null;

    this.state = {
      fetching: false,
      error: '',
      status: 'default',

      mailing: null,
      listsById: {},

      eventsByEmail: {},
      numEvents: 0,
      numDelivered: 0,
      numOpened: 0,
      numClicked: 0,
      numFailed: 0
    }
  }

  componentDidMount() {
    const { mailingId } = this.props.match.params;

    this.setState({
      fetching: true
    });

    // get lists
    API.call('GET', Settings.V3_API_URL + '/recipient-lists', {}, (response, error) => {
      if (error) {
        this.setState({
          fetching: false,

          error: error.message + ' while getting lists'
        });

        return false;
      }

      let listsById = {};
      response.data.lists.forEach((list) => {
        listsById[list.id] = list;
      });
      this.setState({
        listsById: listsById
      }, () => {
        // get mailing
        API.call('GET', Settings.V3_API_URL + '/mailing-queues', {}, (response, error) => {
          if (error) {
            this.setState({
              fetching: false,

              error: error.message + ' while getting queues'
            });

            return false;
          }

          response.data.queues.forEach((queue) => {
            if (queue.id == mailingId) {
              this.setState({
                mailing: queue
              });
            }
          });

          this.setState({
            fetching: false,

            mailings: response.data.queues
          });
        });
      });
    });

    const getEvents = () => {
      console.log('Fetch events...');

      API.call('GET', Settings.V3_API_URL + '/reports/mailings/' + mailingId, {}, (response, error) => {
        if (error) {
          this.setState({
            fetching: false,

            error: error.message + ' while getting events report'
          });

          return false;
        }

        let eventsByEmail = {};

        response.data.events_by_email.forEach((summary) => {
          eventsByEmail[summary.email] = summary.events;
        });

        this.setState({
          numEvents: response.total_count,
          numDelivered: response.num_delivered,
          numOpened: response.num_opened,
          numClicked: response.num_clicked,
          numFailed: response.num_failed,

          eventsByEmail: eventsByEmail
        });
      });
    }

    // get events right away
    getEvents();

    // update every x seconds
    const timeout = 10;
    window.clearInterval(this.statsFetchT);
    this.statsFetchT = window.setInterval(getEvents, 1000*timeout);
  }

  componentWillUnmount() {
    window.clearInterval(this.statsFetchT);
  }

  render() {
    let stats = null;

    if (this.state.numEvents == 0) {
      stats = <Spinner message="Attendo statistiche..." />
    } else {
      stats = (
        <div>
          <h3>
          <span className="badge badge-success mr-2">{this.state.numClicked} CLICKED <small>({(this.state.numClicked / (this.state.numEvents / 100)).toFixed(2) + '%'})</small></span>
          <span className="badge badge-warning mr-2">{this.state.numOpened} OPENED <small>({(this.state.numOpened / (this.state.numEvents / 100)).toFixed(2) + '%'})</small></span>
          <span className="badge badge-info mr-2">{this.state.numDelivered} DELIVERED <small>({(this.state.numDelivered / (this.state.numEvents / 100)).toFixed(2) + '%'})</small></span>
          <span className="badge badge-danger mr-2">{this.state.numFailed} FAILED <small>({(this.state.numFailed / (this.state.numEvents / 100)).toFixed(2) + '%'})</small></span>
            <small> in {this.state.numEvents} destinatari</small>
          </h3>
        </div>
      );
    }

    return (
      this.state.error ? (
        <div className="alert alert-danger">
          <h2>Oh, mamma!</h2><p>{this.state.error}</p>
        </div>
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-12">
              {
                this.state.mailing ? (
                  <div>
                    <h1><i className="fa fa-mail-bulk" /> {this.state.mailing.name}</h1>

                    {stats}

                    {
                      this.state.mailing.lists.map((listId) => {
                        const list = this.state.listsById[listId];

                        if (list) {
                          let recipients = [];

                          recipients = list.schools.map((schoolId) => {
                            const school = this.props.appData.cache.schoolsById[schoolId];

                            return {
                              type: 'school',
                              name: school.name,
                              email: school.email
                            };
                          });

                          list.teachers.forEach((teacherId) => {
                            recipients.push({
                              type: 'teacher',
                              name: teacherId,
                              email: teacherId.split('_')[0].toLowerCase()
                            });
                          });

                          recipients.sort((a, b) => {
                            if (a.email < b.email) {
                              return -1;
                            }
                            if (a.email > b.email) {
                              return 1;
                            }

                            return 0;
                          });

                          const listElems = recipients.map((recipient) => {
                            return (
                              <div style={{padding: '12px 0', borderBottom: '1px solid #ccc'}}>
                                <i className={'fa ' + (recipient.type == 'school' ? 'fa-school' : 'fa-chalkboard-teacher') + ' mr-2'} />

                                {recipient.name}

                                {
                                  this.state.eventsByEmail[recipient.email] && this.state.eventsByEmail[recipient.email].indexOf('failed') != -1 ? (
                                    <div className="badge badge-danger float-right ml-1">FAILED</div>
                                  ) : ''
                                }
                                {
                                  this.state.eventsByEmail[recipient.email] && this.state.eventsByEmail[recipient.email].indexOf('delivered') != -1 ? (
                                    <div className="badge badge-info float-right ml-1">DELIVERED</div>
                                  ) : ''
                                }
                                {
                                  this.state.eventsByEmail[recipient.email] && this.state.eventsByEmail[recipient.email].indexOf('opened') != -1 ? (
                                    <div className="badge badge-warning float-right ml-1">OPENED</div>
                                  ) : ''
                                }
                                {
                                  this.state.eventsByEmail[recipient.email] && this.state.eventsByEmail[recipient.email].indexOf('clicked') != -1 ? (
                                    <div className="badge badge-success float-right ml-1">CLICKED</div>
                                  ) : ''
                                }

                                {
                                  !this.state.eventsByEmail[recipient.email] ? (
                                    <div className="float-right"><small style={{fontSize: '9px'}}>¯\_(ツ)_/¯</small></div>
                                  ) : ''
                                }
                              </div>
                            );
                          });

                          return (
                            <div>
                              <h2 className="mt-4">
                                <i className="far fa-stream" /> {list.name} · {list.schools.length} scuole · {list.teachers.length} insegnanti · {list.emails.length} destinatari hardcodati
                              </h2>

                              {listElems}
                            </div>
                          );
                        }
                      })
                    }
                  </div>
                ) : ""
              }
            </div>
          </div>
        </div>
      )
    );
  }
}

export default MailingViewerPage;


// WEBPACK FOOTER //
// ./src/pages/marketing/mailings/MailingViewerPage.js